// 小程序配置
// #ifndef H5
// 请求域名 格式： https://您的域名
export const HTTP_REQUEST_URL = import.meta.env.VITE_APP_HOST_URL
// #endif
// H5配置
// #ifdef H5
//H5接口是浏览器地址，非单独部署不用修改
var getOpenUrl = (function() {
	return window.location.protocol + '//' + window.location.host
})()
export const HTTP_REQUEST_URL = import.meta.env.VITE_USER_NODE_ENV === 'production' ? getOpenUrl : import.meta.env
	.VITE_APP_HOST_URL
//.replace(/^https?:/, '')
// #endif 

//系统ID与平台
export const PLATFORM = {
	'Xc-Sys-Id': import.meta.env.VITE_APP_SYS_ID,
	// #ifdef MP-TOUTIAO	
	'Xc-App-Platform': 'mp-toutiao',
	// #endif
	// #ifdef MP-WEIXIN
	'Xc-App-Platform': 'mp-weixin',
	// #endif
	// #ifdef MP-QQ
	'Xc-App-Platform': 'mp-qq',
	// #endif
	// #ifdef MP-BAIDU
	'Xc-App-Platform': 'mp-baidu',
	// #endif
	// #ifdef MP-KUAISHOU
	'Xc-App-Platform': 'mp-kuaishou',
	// #endif
	// #ifdef MP-ALIPAY
	'Xc-App-Platform': 'mp-ali',
	// #endif
	// #ifdef QUICKAPP-WEBVIEW || QUICKAPP-WEBVIEW-HUAWEI
	'Xc-App-Platform': 'quickapp',
	// #endif
	// #ifdef H5
	'Xc-App-Platform': 'h5',
	// #endif
	// #ifdef APP
	'Xc-App-Platform': 'app',
	// #endif
}
// 以下配置在不做二开的前提下,不需要做任何的修改
export const HEADER = {
	'Xc-Locale': uni.getLocale(),
	// #ifdef APP-PLUS
	'Xc-App-Version': import.meta.env.VITE_APP_APP_VERSION,
	'Xc-App-Channel': plus.runtime.channel,
	'Xc-App-Version-Name': plus.runtime.version,
	// #endif
	// #ifndef APP-PLUS
	'Xc-App-Version': import.meta.env.VITE_APP_APP_VERSION,
	'Xc-App-Version-Name': import.meta.env.VITE_APP_APP_VERSION_NAME
	// #endif
}
export const APP_VERSION = import.meta.env.VITE_APP_APP_VERSION
export const APP_VERSION_NAME = import.meta.env.VITE_APP_APP_VERSION_NAME
// 回话密钥名称 请勿修改此配置
export const TOKEN_NAME = 'Xc-User-Token'
// 缓存时间 0 永久
export const EXPIRE = 0
//购物车到期时间
export const MY_CART_EXPIRE = 36000